import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-11c7f492"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header-bar", {
      'disabled-header': $setup.isDisabled
    }])
  }, [_createElementVNode("div", {
    class: "header-left"
  }, [_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    onClick: $setup.goBack
  })]), _createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "more", {}, undefined, true), _createVNode($setup["LoginBox"])])], 2);
}